var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinvLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 539.99792,
    height: 131.1608,
    viewBox: "0 0 539.99792 131.1608",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    id: "path21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    id: "path23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    id: "path25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-245.02881,-293.14551)",
    id: "path27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-265.42531,-306.02441)",
    id: "path29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-284.13961,-298.71491)",
    id: "path31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-296.73781,-315.39551)",
    id: "path33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-270.66801,-320.42581)",
    id: "path35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-339.23731,-333.95411)",
    id: "path115"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    id: "path117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-377.23251,-353.35941)",
    id: "path119"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    id: "path121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-392.71101,-338.49711)",
    id: "path123"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-404.56061,-353.35941)",
    id: "path125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-432.31061,-333.95411)",
    id: "path127"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-440.77841,-343.95321)",
    id: "path129"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-455.59091,-338.49711)",
    id: "path131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-467.31741,-353.35941)",
    id: "path133"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-492.57331,-337.36141)",
    id: "path135"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath137"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-513.63091,-336.32431)",
    id: "path137"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-327.38681,-293.8614)",
    id: "path139"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-359.80181,-309.85941)",
    id: "path141"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-374.09571,-310.74811)",
    id: "path143"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-387.37701,-309.85941)",
    id: "path145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-410.13871,-300.45321)",
    id: "path147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-429.76661,-299.78621)",
    id: "path149"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-320.12801,-266.2476)",
    id: "path151"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-345.80281,-261.70461)",
    id: "path153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-357.30771,-264.0738)",
    id: "path155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-377.72561,-265.1109)",
    id: "path157"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-399.35161,-261.70461)",
    id: "path159"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-423.84281,-281.10891)",
    id: "path161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath163"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-429.44541,-266.2476)",
    id: "path163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-447.83791,-281.10891)",
    id: "path165"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-473.14261,-261.70461)",
    id: "path167"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-476.47561,-257.4585)",
    id: "path169"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-499.83011,-271.70271)",
    id: "path171"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-524.14751,-261.70461)",
    id: "path173"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-532.12111,-271.70271)",
    id: "path175"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-547.03321,-281.10891)",
    id: "path177"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-572.09182,-270.3453)",
    id: "path179"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-595.34671,-261.70461)",
    id: "path181"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    id: "path183"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-611.32042,-281.10891)",
    id: "path185"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z",
    transform: "translate(-634.08401,-261.70461)",
    id: "path187"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC1",
    transform: "translate(-314.17005,-322.23186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 387.006,322.251 h -67.328 v 2.963 h 67.328 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    clipPath: "url(#clipPath21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m 454.304,322.251 h -67.328 v 2.963 h 67.328 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    clipPath: "url(#clipPath23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m 521.6,322.251 h -67.328 v 2.963 H 521.6 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    clipPath: "url(#clipPath25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 0,0 c 0,0 9.759,-10.8 13.142,-13.143 3.383,-2.341 10.019,-5.724 10.019,-5.724 0,0 5.725,1.821 8.328,4.164 2.602,2.342 14.443,14.053 14.443,14.572 0,0.522 -3.253,5.727 -5.595,6.377 C 37.995,6.896 33.44,5.335 32.269,4.684 31.099,4.033 29.667,8.848 27.585,9.759 25.503,10.67 21.339,12.36 19.908,11.84 18.477,11.32 13.272,6.766 13.272,5.725 13.272,4.684 9.759,7.807 7.677,7.287 5.595,6.766 -0.13,1.562 0,0",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,326.70507,402.846)",
    clipPath: "url(#clipPath27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M 0,0 C 0.732,0.161 1.519,0.256 2.383,0.256 3.166,0.256 3.888,0.174 4.558,0.032 4.537,0.277 4.526,0.519 4.51,0.764 H 0.064 C 0.043,0.509 0.026,0.254 0,0",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,353.9004,385.67413)",
    clipPath: "url(#clipPath29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m 0,0 c -0.414,0.119 -0.835,0.178 -1.256,0.178 -2.948,0 -5.044,-2.95 -5.133,-3.077 l -1.825,-2.609 -0.463,3.149 c -0.046,0.301 -1.195,7.398 -7.654,7.398 -6.771,0 -7.963,-6.974 -8.011,-7.271 l -0.512,-3.198 -1.792,2.697 c -0.078,0.121 -1.967,2.955 -4.894,2.955 -0.573,0 -1.153,-0.112 -1.727,-0.332 -2.439,-0.934 -4.116,-4.279 -4.57,-5.274 l -0.034,-0.078 0.044,-0.067 c 5.332,-7.74 13.153,-14.265 21.461,-17.894 l 0.053,-0.02 0.056,0.02 c 7.972,3.248 15.638,9.55 21.027,17.282 L 4.811,-6.083 4.79,-6.02 C 4.363,-4.499 3.039,-0.879 0,0",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,378.8528,395.42013)",
    clipPath: "url(#clipPath31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m 0,0 c -0.139,-6.785 -2.127,-13.468 -5.912,-19.847 l -0.14,-0.238 -0.113,0.252 c -0.927,2.058 -2.672,4.697 -5.737,5.576 -2.526,0.732 -5.04,0.06 -7.339,-1.929 l -0.155,-0.132 -0.073,0.192 c -0.563,1.498 -2.004,4.396 -4.988,5.954 -1.643,0.945 -3.69,1.057 -4.472,1.057 -0.864,0 -2.828,-0.026 -4.696,-1.076 -3.035,-1.547 -4.509,-4.368 -5.089,-5.83 l -0.076,-0.187 -0.153,0.13 c -1.132,0.975 -2.962,2.144 -5.238,2.144 -0.859,0 -1.73,-0.167 -2.588,-0.497 -2.4,-0.921 -4.137,-3.241 -5.171,-5.025 l -0.12,-0.209 -0.126,0.206 c -3.686,6.224 -5.7,12.843 -5.982,19.669 -0.143,3.454 -0.215,7.079 -0.215,10.771 0,11.405 0.677,20.615 0.968,24.046 l 0.011,0.129 H -0.498 L -0.494,35.02 C -0.315,31.304 0.093,21.379 0.093,9.549 0.093,6.248 0.064,3.035 0,0 m -7.829,-22.821 c -5.388,-7.733 -13.054,-14.034 -21.026,-17.283 l -0.056,-0.02 -0.053,0.02 c -8.308,3.629 -16.129,10.155 -21.461,17.894 l -0.044,0.067 0.033,0.079 c 0.455,0.995 2.132,4.339 4.571,5.274 0.573,0.22 1.154,0.332 1.726,0.332 2.928,0 4.817,-2.835 4.895,-2.955 l 1.791,-2.697 0.513,3.197 c 0.047,0.297 1.24,7.271 8.011,7.271 6.459,0 7.608,-7.096 7.654,-7.398 l 0.463,-3.148 1.825,2.608 c 0.089,0.128 2.185,3.077 5.133,3.077 0.421,0 0.842,-0.058 1.256,-0.178 3.039,-0.879 4.363,-4.499 4.79,-6.019 l 0.02,-0.064 z m 9.986,59.419 -0.07,1.286 h -61.974 l -0.123,-1.228 c -0.016,-0.165 -1.682,-17.374 -0.884,-36.56 0.864,-20.827 16.903,-36.873 31.438,-42.971 l 0.507,-0.208 0.514,0.199 c 14.794,5.724 30.746,22.686 31.161,42.827 0.39,18.998 -0.558,36.489 -0.569,36.655",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,395.6504,373.17933)",
    clipPath: "url(#clipPath33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 0,0 c 3.606,-0.059 10.645,-0.192 16.91,1.836 0,0 -0.166,-2.17 -0.166,-4.693 0,-2.521 0.166,-4.687 0.166,-4.687 C 11.164,-5.689 4.064,-5.65 0,-5.698 v -13.444 h -5.697 v 13.444 c -4.066,0.048 -11.165,0.009 -16.913,-1.846 0,0 0.166,2.166 0.166,4.687 0,2.523 -0.166,4.693 -0.166,4.693 C -16.344,-0.192 -9.306,-0.059 -5.697,0 v 8.444 c -3.288,0.024 -8.027,-0.125 -13.384,-1.859 0,0 0.166,2.168 0.166,4.689 0,2.527 -0.166,4.689 -0.166,4.689 5.348,-1.724 10.08,-1.881 13.367,-1.853 -0.169,5.345 -1.78,12.082 -1.78,12.082 0,0 3.318,-0.249 4.643,-0.249 1.329,0 4.646,0.249 4.646,0.249 0,0 -1.612,-6.737 -1.78,-12.082 3.287,-0.028 8.019,0.129 13.366,1.853 0,0 -0.164,-2.162 -0.164,-4.689 0,-2.521 0.164,-4.689 0.164,-4.689 C 8.026,8.319 3.287,8.468 0,8.444 V 0",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,360.89067,366.47227)",
    clipPath: "url(#clipPath35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M 0,0 V 12.937 L -6.691,0 h -2.642 l -6.493,12.715 V 0 h -2.963 v 19.405 h 3.21 L -7.926,3.876 0,19.405 H 2.962 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,452.3164,348.43453)",
    clipPath: "url(#clipPath115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "m 351.58,333.954 h -2.962 v 19.405 h 2.962 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    clipPath: "url(#clipPath117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M 0,0 V -19.405 H -2.395 L -16.27,-4.962 v -14.443 h -2.963 V 0 h 2.42 l 13.85,-14.468 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,502.97667,322.5608)",
    clipPath: "url(#clipPath119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "m 386.612,333.954 h -2.963 v 19.405 h 2.963 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    clipPath: "url(#clipPath121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 0,0 c 0.864,-0.988 2.765,-2.074 4.32,-2.074 1.803,0 3.111,1.037 3.111,2.814 0,3.358 -8.098,2.889 -8.098,8.815 0,3.456 2.864,5.554 5.679,5.554 1.827,0 3.21,-0.667 3.974,-1.333 V 9.999 c -0.691,1.012 -2.173,2.37 -3.95,2.37 -1.654,0 -2.716,-1.111 -2.716,-2.691 0,-3.629 8.172,-3.012 8.172,-8.814 0,-3.63 -3.036,-5.753 -6.27,-5.753 -1.803,0 -3.309,0.692 -4.222,1.506 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,523.61467,342.3772)",
    clipPath: "url(#clipPath123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M 0,0 H 15.604 V -2.765 H 9.283 v -16.64 H 6.32 v 16.64 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,539.41413,322.5608)",
    clipPath: "url(#clipPath125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M 0,0 H -9.061 V 19.405 H 0 v -2.764 h -6.098 v -5.556 h 4.321 V 8.345 H -6.098 V 2.74 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,576.41413,348.43453)",
    clipPath: "url(#clipPath127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 0,0 h 1.136 c 2.567,0 4.173,1.062 4.173,3.407 0,2.246 -1.556,3.235 -4.099,3.235 L 0,6.642 Z M 2.716,-2.593 C 2.173,-2.666 1.605,-2.716 1.013,-2.716 H 0 V -9.999 H -2.963 V 9.406 h 4.074 c 4.469,0 7.382,-1.827 7.382,-6.049 0,-2.246 -1.061,-3.9 -2.764,-4.913 l 7.677,-8.443 H 9.233 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,587.70453,335.1024)",
    clipPath: "url(#clipPath129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "m 0,0 c 0.864,-0.988 2.765,-2.074 4.32,-2.074 1.803,0 3.112,1.037 3.112,2.814 0,3.358 -8.099,2.889 -8.099,8.815 0,3.456 2.864,5.554 5.679,5.554 1.827,0 3.209,-0.667 3.974,-1.333 V 9.999 c -0.691,1.012 -2.173,2.37 -3.95,2.37 -1.654,0 -2.716,-1.111 -2.716,-2.691 0,-3.629 8.172,-3.012 8.172,-8.814 0,-3.63 -3.036,-5.753 -6.27,-5.753 -1.803,0 -3.309,0.692 -4.222,1.506 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,607.45453,342.3772)",
    clipPath: "url(#clipPath131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M 0,0 H 15.604 V -2.765 H 9.283 v -16.64 H 6.32 v 16.64 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,623.08987,322.5608)",
    clipPath: "url(#clipPath133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M 0,0 5.802,15.998 H 8.986 L 1.456,-3.407 h -3.11 l -7.012,19.405 h 3.185 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,656.7644,343.89147)",
    clipPath: "url(#clipPath135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M 0,0 C 4.346,0.074 7.012,3.383 6.939,7.505 6.839,11.727 4.197,14.393 0.1,14.418 -4.913,14.393 -6.765,10.098 -6.739,7.233 -6.813,3.9 -4.962,0.05 0,0 M 0.1,17.158 C 5.803,17.109 9.876,13.48 9.999,7.629 10.099,1.901 6,-2.642 -0.049,-2.74 c -6.888,0.074 -9.85,5.357 -9.776,9.973 -0.026,4 2.962,9.901 9.925,9.925",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,684.8412,345.27427)",
    clipPath: "url(#clipPath137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M 0,0 5.802,15.998 H 8.986 L 1.456,-3.407 h -3.11 l -7.012,19.405 h 3.185 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,436.51573,401.89147)",
    clipPath: "url(#clipPath139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "m 0,0 v -19.405 h -2.396 l -13.875,14.443 v -14.443 h -2.961 V 0 h 2.418 L -2.963,-14.468 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,479.73573,380.5608)",
    clipPath: "url(#clipPath141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M 0,0 -1.58,1.506 1.976,5.185 3.63,3.457 Z m -5.406,-0.889 v -9.283 c 0,-3.999 1.802,-7.802 6.27,-7.802 3.703,0 6.246,2.939 6.246,7.778 v 9.307 h 2.963 v -9.283 c 0,-6.295 -3.802,-10.493 -9.209,-10.493 -6.419,0 -9.233,4.371 -9.233,10.469 v 9.307 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,498.79427,379.37587)",
    clipPath: "url(#clipPath143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 0,0 h 15.603 v -2.765 h -6.32 v -16.64 H 6.32 v 16.64 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,516.50267,380.5608)",
    clipPath: "url(#clipPath145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "m 0,0 h 1.136 c 2.567,0 4.173,1.062 4.173,3.407 0,2.246 -1.556,3.235 -4.099,3.235 L 0,6.642 Z M 2.716,-2.593 C 2.173,-2.666 1.605,-2.716 1.013,-2.716 H 0 V -9.999 H -2.962 V 9.406 h 4.073 c 4.469,0 7.382,-1.827 7.382,-6.049 0,-2.246 -1.061,-3.9 -2.765,-4.913 l 7.678,-8.443 H 9.233 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,546.8516,393.1024)",
    clipPath: "url(#clipPath147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M 0,0 H 4.592 L 2.32,6.543 Z M 3.851,10.073 11.035,-9.332 H 7.851 L 5.555,-2.74 h -6.518 l -2.321,-6.592 h -3.185 l 7.431,19.405 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,573.02213,393.99173)",
    clipPath: "url(#clipPath149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "m 0,0 c 0.864,-0.988 2.765,-2.074 4.32,-2.074 1.803,0 3.112,1.037 3.112,2.814 0,3.358 -8.099,2.889 -8.099,8.815 0,3.455 2.864,5.554 5.679,5.554 1.827,0 3.209,-0.668 3.974,-1.334 V 9.998 c -0.691,1.012 -2.173,2.371 -3.95,2.371 -1.654,0 -2.716,-1.111 -2.716,-2.691 0,-3.629 8.172,-3.012 8.172,-8.815 0,-3.629 -3.036,-5.752 -6.27,-5.752 -1.803,0 -3.309,0.692 -4.222,1.506 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,426.83733,438.70987)",
    clipPath: "url(#clipPath151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "m 0,0 h -10.245 v 19.404 h 2.962 V 2.74 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,461.0704,444.7672)",
    clipPath: "url(#clipPath153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M 0,0 C 4.346,0.074 7.012,3.383 6.937,7.506 6.839,11.729 4.197,14.395 0.1,14.418 -4.912,14.395 -6.765,10.098 -6.739,7.234 -6.813,3.9 -4.962,0.051 0,0 M 0.1,17.158 C 5.803,17.109 9.876,13.48 9.999,7.629 10.098,1.902 6,-2.641 -0.049,-2.74 c -6.888,0.074 -9.85,5.357 -9.776,9.974 -0.026,4 2.962,9.901 9.925,9.924",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,476.41027,441.60827)",
    clipPath: "url(#clipPath155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M 0,0 5.802,15.998 H 8.986 L 1.456,-3.406 h -3.11 l -7.012,19.404 h 3.185 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,503.63413,440.22547)",
    clipPath: "url(#clipPath157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M 0,0 H -9.061 V 19.404 H 0 v -2.763 h -6.098 v -5.557 h 4.321 V 8.344 H -6.098 V 2.74 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,532.4688,444.7672)",
    clipPath: "url(#clipPath159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "m 0,0 v -19.404 h -2.396 l -13.875,14.443 v -14.443 h -2.961 V 0 h 2.418 L -2.963,-14.467 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,565.12373,418.8948)",
    clipPath: "url(#clipPath161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "m 0,0 c 0.864,-0.988 2.765,-2.074 4.32,-2.074 1.803,0 3.111,1.037 3.111,2.814 0,3.358 -8.098,2.889 -8.098,8.815 0,3.455 2.864,5.554 5.679,5.554 1.827,0 3.21,-0.668 3.974,-1.334 V 9.998 c -0.691,1.012 -2.173,2.371 -3.95,2.371 -1.654,0 -2.716,-1.111 -2.716,-2.691 0,-3.629 8.172,-3.012 8.172,-8.815 0,-3.629 -3.036,-5.752 -6.27,-5.752 -1.803,0 -3.309,0.692 -4.222,1.506 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,572.59387,438.70987)",
    clipPath: "url(#clipPath163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M 0,0 V -9.555 L 8.469,0 h 3.95 l -8.987,-9.752 8.913,-9.652 h -4 L 0,-10.146 v -9.258 H -2.962 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,597.1172,418.8948)",
    clipPath: "url(#clipPath165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M 0,0 H -9.06 V 19.404 H 0 v -2.763 h -6.098 v -5.557 h 4.321 V 8.344 H -6.098 V 2.74 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,630.8568,444.7672)",
    clipPath: "url(#clipPath167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M 0,0 C 1.728,1.48 2.567,3.555 2.592,5.998 V 23.65 H 5.579 V 6.023 c 0,-3.48 -1.308,-6.294 -3.679,-8.246 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,635.3008,450.42867)",
    clipPath: "url(#clipPath169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "m 0,0 h 1.136 c 2.567,0 4.173,1.062 4.173,3.408 0,2.246 -1.556,3.235 -4.099,3.235 H 0 Z M 2.716,-2.592 C 2.173,-2.666 1.605,-2.715 1.013,-2.715 H 0 V -9.998 H -2.962 V 9.406 h 4.073 c 4.469,0 7.382,-1.826 7.382,-6.049 0,-2.246 -1.061,-3.9 -2.765,-4.912 l 7.678,-8.443 H 9.233 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,666.44013,431.4364)",
    clipPath: "url(#clipPath171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M 0,0 H -9.06 V 19.404 H 0 v -2.763 h -6.098 v -5.557 h 4.321 V 8.344 H -6.098 V 2.74 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,698.86333,444.7672)",
    clipPath: "url(#clipPath173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "m 0,0 h 1.136 c 2.567,0 4.173,1.062 4.173,3.408 0,2.246 -1.556,3.235 -4.099,3.235 H 0 Z M 0,-2.715 V -9.998 H -2.962 V 9.406 h 4.073 c 4.469,0 7.382,-1.826 7.382,-6.049 0,-3.925 -3.308,-6.072 -7.48,-6.072 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,709.4948,431.4364)",
    clipPath: "url(#clipPath175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "m 0,0 v -9.283 c 0,-3.998 1.802,-7.801 6.271,-7.801 3.703,0 6.246,2.938 6.246,7.777 V 0 h 2.962 v -9.283 c 0,-6.295 -3.801,-10.492 -9.208,-10.492 -6.419,0 -9.234,4.371 -9.234,10.468 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,729.3776,418.8948)",
    clipPath: "url(#clipPath177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "m 0,0 h -1.185 v -5.9 h 1.086 c 3.086,0 5.086,0.394 5.086,2.888 C 4.987,-0.518 2.863,0 0,0 m -0.37,2.74 c 2.296,0 3.629,0.791 3.629,2.592 0,2.197 -2.173,2.691 -4.025,2.691 H -1.185 V 2.74 Z M -4.147,-8.641 v 19.405 h 2.764 c 4.345,0 7.654,-1.358 7.654,-5.284 0,-1.925 -1.038,-3.037 -2.839,-3.58 2.79,-0.517 4.641,-2.023 4.641,-4.863 0,-4.766 -4.567,-5.678 -8.543,-5.678 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,762.78907,433.24627)",
    clipPath: "url(#clipPath179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "m 0,0 h -10.246 v 19.404 h 2.963 V 2.74 H 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,793.7956,444.7672)",
    clipPath: "url(#clipPath181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "m 601.692,261.705 h -2.963 v 19.404 h 2.963 z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    clipPath: "url(#clipPath183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M 0,0 V -9.555 L 8.469,0 h 3.95 l -8.987,-9.752 8.913,-9.652 h -4 L 0,-10.146 v -9.258 H -2.962 V 0 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,815.09387,418.8948)",
    clipPath: "url(#clipPath185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "m 0,0 h -2.963 v 7.703 l -6.394,11.701 h 3.407 l 4.641,-8.763 4.444,8.763 H 6.542 L 0,7.652 Z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,845.44533,444.7672)",
    clipPath: "url(#clipPath187)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinvLogo);
export default __webpack_public_path__ + "static/media/minv-logo.c1d5677c23fec89efbebecf6890b2400.svg";
export { ForwardRef as ReactComponent };